import React from 'react';
import PublicLayout from '../../components/layout/PublicLayout';

const AboutUsScreen = () => {
  return (
    <PublicLayout title="About Us">
          <h2>About Us – MeetUrExpert App</h2>
          <p><strong>India’s First Multi-Disciplinary Platform for Sports-Specific Experts</strong></p>
          <p>MeetUrExpert is a first-of-its-kind digital platform designed to connect athletes, coaches, parents, and institutions with certified, sports-specific professionals across India. Whether you’re an aspiring athlete from a small town or a seasoned professional competing nationally, MeetUrExpert helps you access expert guidance, injury care, and performance coaching—anytime, anywhere.</p>
          <p>MeetUrExpert is proudly developed and powered by AthlignEdu Tech Pvt. Ltd., a pioneering force in sports injury management and sports science education in India.</p>
          <h2>Why MeetUrExpert Was Created?</h2>
          <p>In India, there are thousands of talented athletes—but only a few have access to proper scientific training, injury care, or expert mentoring. Many athletes suffer setbacks not due to lack of talent, but due to:</p>
          <ul>
            <li>Mismanaged injuries</li>
            <li>Poor recovery planning</li>
            <li>Unqualified coaching or advice</li>
            <li>Lack of access to the right experts at the right time</li>
          </ul>
          <p>MeetUrExpert was created to solve this very problem. It is more than an app—it’s a movement to democratize access to trusted sports professionals, especially for grassroots athletes, academies, and sports parents.</p>
          <h2>Founded by Experts. Built for Athletes.</h2>
          <p>MeetUrExpert is the brainchild of Dr.Mukti Prasad Dash, a nationally recognized Sports Science Expert & Sports Physiotherapist with over 20 years of experience working with Indian Football, Hockey, Olympic Team and multiple elite athletes.</p>
          <p>His parent company, AthlignEdu Tech Pvt. Ltd., was founded to revolutionize India’s approach to injury care and professional sports education. MeetUrExpert is Athlign’s flagship digital brand, launched to scale its mission nationwide through technology.</p>
          <blockquote>
            “Athletes must have access to the right experts at every step—not just when they’re injured, but also when they’re training, recovering, or even planning their diet. MeetUrExpert brings all of this to one place.”<br />
            — Dr.Mukti Prasad Dash, Founder, Athlign & MeetUrExpert & Global Physio Cell.
          </blockquote>
          <h2>What MeetUrExpert Offers?</h2>
          <ul>
            <li><strong>Online & In-Clinic Consultation</strong><br />Connect with experts via video consultation or book in-person visits at their clinics</li>
            <li><strong>16 Sports-Specific Professional Categories</strong><br />All professionals are verified, certified, and experienced in working with athletes:
              <ol>
                <li>Sports Medicine Doctors</li>
                <li>Sports Physiotherapists</li>
                <li>Exercise Physiologists</li>
                <li>Sports Science Experts</li>
                <li>Strength & Conditioning Coaches</li>
                <li>Fitness Trainers</li>
                <li>Sports Dieticians</li>
                <li>Sports Psychologists</li>
                <li>Sports Surgeons</li>
                <li>Sports Yoga Specialists</li>
                <li>Biomechanics Experts</li>
                <li>Coaches (All Disciplines)</li>
                <li>Physical Education Teachers</li>
                <li>Sports Video Analysts</li>
                <li>Sports Massage Experts</li>
                <li>Sports Diagnostics</li>
              </ol>
            </li>
            <li><strong>Structured Assessment & Injury Referral</strong>
              <ul>
                <li>Upload your reports for expert analysis</li>
                <li>Receive customized plans for rehab or training</li>
                <li>Get referred to trusted professionals nearby</li>
              </ul>
            </li>
            <li><strong>Rehab Tracking & Return-to-Sport Monitoring</strong>
              <ul>
                <li>Progress dashboards</li>
                <li>Therapist-coach communication</li>
                <li>Return-to-play readiness tools</li>
              </ul>
            </li>
            <li><strong>Knowledge & Learning Center</strong>
              <ul>
                <li>Expert video series</li>
                <li>Podcasts</li>
                <li>Webinars and Q&A sessions for athletes and parents</li>
              </ul>
            </li>
          </ul>
          <h2>Who Can Use MeetUrExpert?</h2>
          <ol>
            <li><strong>Athletes</strong><br />From school-level to elite performers—get expert help in training, recovery, and injury prevention.</li>
            <li><strong>Parents</strong><br />Ensure your child gets safe, scientific, and age-appropriate guidance from trusted professionals.</li>
            <li><strong>Schools & Academies</strong><br />Partner with our network to ensure your athletes stay injury-free and professionally monitored.</li>
            <li><strong>Professionals</strong><br />Physios, trainers, coaches, and others can join the platform to build credibility, reach more clients, and grow their career.</li>
            <li><strong>High Performance Centre</strong><br />Access a verified pool of specialists to deliver advanced care, training, and monitoring for elite athletes</li>
            <li><strong>Sports Clubs</strong><br />Strengthen your club’s support system with professional injury management, conditioning, and recovery solutions.</li>
            <li><strong>Sports Associations</strong><br />Collaborate with our expert network to enhance athlete development through structured injury prevention, rehabilitation, and performance science programs.</li>
            <li><strong>Sports Science Centre</strong><br />Integrate our network’s multidisciplinary expertise to offer comprehensive assessment, rehab, and research-driven performance services.</li>
          </ol>
          <h2>Powered by AthlignEdu Tech Pvt. Ltd.</h2>
          <p>MeetUrExpert is the official digital initiative of AthlignEdutechPvt. Ltd., a company committed to:</p>
          <ul>
            <li>Evidence-based sports injury care</li>
            <li>Professional training and certification</li>
            <li>Partnering with leagues, schools, and institutions</li>
            <li>Promoting athlete-first ecosystems across India</li>
          </ul>
          <h3>About Athlign:</h3>
          <ul>
            <li>Founded in 18/05/2025</li>
            <li>Led by Dr.Mukti Prasad Dash (Ex-Physio – Indian National Teams)</li>
            <li>Based in Odisha, working pan-India</li>
            <li>Offers injury partnerships, rehab programs, and professional education</li>
          </ul>
          <p>With MeetUrExpert, Athlign brings its high-quality, hands-on expertise to the fingertips of every Indian athlete.</p>
          <h2>Our Vision</h2>
          <p>To build India’s largest, most reliable, and most athlete-focused digital ecosystem where every sportsperson—regardless of background—can access the expert guidance they need to thrive.</p>
          <h2>Our Goals for 2025–2026</h2>
          <ul>
            <li>1 Lakh+ athletes served</li>
            <li>5,000+ certified professionals onboarded</li>
            <li>Presence in 500+ cities and districts</li>
            <li>Institutional tie-ups with 200+ schools and academies</li>
            <li>Launch of expert-led short courses for users and professionals</li>
          </ul>
          <h2>Partner With Us</h2>
          <p>Are you a sports academy, school, team, or professional looking to be part of something impactful?<br />Join our ecosystem and help create India’s strongest support network for athletes.</p>
          <h2>Contact Us</h2>
          <ul>
            <li>📧 Email: <a href="mailto:office@meeturexpert.in">office@meeturexpert.in</a>, <a href="mailto:office@athlignedutech.com">office@athlignedutech.com</a></li>
            <li>🌐 Website: <a href="https://www.meeturexpert.in" target="_blank" rel="noopener noreferrer">www.meeturexpert.in</a>, <a href="https://www.athlignedutech.com" target="_blank" rel="noopener noreferrer">www.athlignedutech.com</a></li>
            <li>📍 Parent Company: AthlignEdu Tech Pvt. Ltd. | Odisha, India</li>
            <li>📱 Social: Instagram | LinkedIn | YouTube | Twitter @meeturexpert</li>
          </ul>
    </PublicLayout>
  );
};

export default AboutUsScreen;
